module.exports = __webpack_public_path__ + "img/thumbnail-sowhatbuy-banner.6bc4bd02.webp";